import { useShallow } from 'zustand/react/shallow'
import { useBoundStore } from '../../../state/bound.store'

export type PermissionLevel = 'free' | 'enterpriseFree' | 'enterprise'

interface WithTierPermissionProps {
    requiredTier: PermissionLevel[]
    fallback?: React.ReactNode
}

// Higher Order Component
export const withTierPermission = <P extends object>(
    Component: React.ComponentType<P>,
    options: WithTierPermissionProps
) => {
    const WithTierPermission = (props: P) => {
        const { tier } = useBoundStore(
            useShallow((s) => ({
                tier: s.tier,
            }))
        )

        const currentTier = (tier || 'free') as PermissionLevel
        const hasPermission = options.requiredTier.includes(currentTier)
        if (!hasPermission) {
            return null
        }

        return <Component {...props} />
    }

    // Set displayName for better debugging
    WithTierPermission.displayName = `WithTierPermission(${
        Component.displayName || Component.name || 'Component'
    })`

    return WithTierPermission
}
